import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getRoles () {
   return Api().get("/authorities");
},
  updateRole (params) {
    return Api().put("/authorities",params);
  },
  addRole (params) {
    return Api().post("/authorities",params);
  },
  getRole (params) {
    return Api().get("/authorities/"+params);
  },
  deleteRole (params) {
    return Api().delete("/authorities/"+params);
  },
  getUsersByRoleNames(params){
    return Api().get("/authorities/users/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/RoleService.js